import { ITab } from "../../../utils/interfaces";

export const TabItems: Array<ITab> = [
    {
        id: 0,
        label: "Book Now",
        src: "/schedule",
        visible: false
    },
    {
        id: 1,
        label: "Ask Ralphie",
        src: "/askRalphie",
        visible: true,
    },
    {
        id: 2,
        label: "My Appointments",
        src: "/appointments",
        visible: false
    },
    {
        id: 3,
        label: "My Pets",
        src: "/pets",
        visible: false
    },
    ,
    {
        id: 4,
        label: "My Schedule",
        src: "/vetSchedule",
        visible: false
    },
    {
        id: 5,
        label: "Preferences",
        src: "/preferences",
        visible: false
    },
    {
        id: 6,
        label: "My Profile",
        src: "/dashboardProfile",
        visible: false
    },
    {
        id: 7,
        label: "Login",
        src: "/login/?login=true",
        visible: true,
    },
    {
        id: 8,
        label: "Sign Up",
        src: "/signUp",
        visible: true
    },
    {
        id: 9,
        label: "Sign Out",
        src: "/login/?login=true",
        visible: false
    }
];
